import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {SharedApiService} from '../../shared/services/api.service';
import {Carousels} from "../../shared/models/carousel.model ";

@Injectable()
export class CarouselsResolver implements Resolve<Carousels> {
    constructor(private apiService: SharedApiService) {
    }

    public resolve(): Observable<Carousels> {
        let carouselCids = [
            'homepage_header',
            'homepage_brands_insulator',
            'homepage_brands_finisher',
            'homepage_brands_plasterer',
            'homepage_brands_painter',
            'homepage_brands_tiler',
            'homepage_brands_fire_applicator',
        ];

        return this.apiService.getCarousels(carouselCids);
    }
}
